import {apiClient} from 'core/apiClient';
import {ApiFilters, ApiPaging, ApiSortings} from 'types/api';

import {
    CreateCustomsUser,
    CustomsUserRow,
    CustomsPaginationContent,
    UpdateCustomsUser,
} from 'types/profile';

const URL = '/customs';

const modifyParams = (params: {filters?: ApiFilters; sortings: ApiSortings}) => {
    const email = params.filters?.find((filter) => filter.id === 'email');
    if (email && Array.isArray(email?.value) && email?.value.length) {
        // @ts-ignore
        email.value = email.value?.[0];
    }

    const phone = params.filters?.find((filter) => filter.id === 'phone');
    if (phone && Array.isArray(phone?.value) && phone?.value.length) {
        // @ts-ignore
        phone.value = phone.value?.[0];
    }
};

export async function fetchCustomsUsersList(params: {
    sortings: ApiSortings;
    filters?: ApiFilters;
    paging: ApiPaging;
    searchField?: string;
    id?: string;
}) {
    const {
        paging: {pageSize, pageNumber},
        id: customsId,
        ...payload
    } = params;
    const mappedPaging = {pageSize, pageNumber: pageNumber + 1};
    modifyParams(payload);

    return (
        await apiClient.post<CustomsPaginationContent<CustomsUserRow>>(
            `${URL}/employee/page`,
            {...payload, paging: mappedPaging},
            {params: {...(customsId && {customsId})}},
        )
    ).data;
}

export async function createCustomsUser(payload: CreateCustomsUser) {
    return (await apiClient.post<CreateCustomsUser>(`${URL}/employee`, payload)).data;
}

export async function updateCustomsUser(payload: UpdateCustomsUser) {
    const {id, customsIdList, ...user} = payload;
    return (await apiClient.put<CreateCustomsUser>(`${URL}/employee/${id}`, {user, customsIdList}))
        .data;
}

export async function removeCustomsUser(id: string | number) {
    return (await apiClient.delete(`${URL}/employee/${id}`)).data;
}

export async function unboundCustomsUser(params: {
    customsId: string | number;
    userId: string | number;
}) {
    return (await apiClient.delete(`${URL}/employee/disconnect`, {params})).data;
}
